import { AccountInfo, InteractionRequiredAuthError } from '@azure/msal-browser';
import { PublicClientApplication } from 'src/utilities/azure/hooks/client';
import { acquireTokenRedirect, acquireTokenSilent, getAccountIdToken } from 'src/utilities/azure/publicClientApplicationUtil';

const getIdToken = async () => {
  // サインイン時に生成されている場合のみトークンの再取得を行う
  if (PublicClientApplication.hasInstance()) {
    // AADB2Cでログイン済みの場合
    const azureAccount = PublicClientApplication.getInstance().getAllAccounts()[0] as undefined | AccountInfo;

    if (azureAccount == null) {
      // 未ログインの場合
      console.error('No account available');
      throw new Error('No account available');
    }

    // NOTE: aquireTokenSilentはexpクレームが有効期限内であればキャッシュからIDトークンを返却すると思われたが、
    // NOTE: 実際のリクエストを観測すると毎回Azureからトークンを取得していてパフォーマンス低下の一因となっていた。
    // NOTE: このため、アカウント情報(キャッシュ)から明示的にIDトークンを取得し、そのIDトークンが有効な間はこれを利用するようにして
    // NOTE: 無効になった場合は再度acquireTokenSilentからIDトークンを取得するようにした。

    // IDトークンの有効期限が切れていない間はアカウント情報からIDトークンを取得する
    const accountIdToken = await getAccountIdToken();
    if (accountIdToken){
      return accountIdToken
    }

    // IDトークンの有効期限が切れた場合はAzureからIDトークンを取得する
    try {
      const acquireTokenSilentResult = await acquireTokenSilent();
      if (acquireTokenSilentResult && acquireTokenSilentResult.idToken) {
        // 直接idTokenを返却
        return acquireTokenSilentResult.idToken;
      }
      throw new Error('No idToken in acquireTokenSilent result');
    } catch (error) {
      console.error('Failed to acquireTokenSilent', error);
      if (error instanceof InteractionRequiredAuthError) {
        await acquireTokenRedirect();
      } else {
        throw error;
      }
    }
  }

  // TODO: LINEログインの場合のトークン更新処理をここに実装

  throw new Error('Not logged in');
};

export const getCommonHeaders = async () => {
  const idToken = await getIdToken();

  return {
    Authorization: bearerOf(idToken),
  };
};

/**
 * @param token token68エンコード済みの文字列
 * @returns `Bearer ${token}`
 */
export const bearerOf = (token: string) => `Bearer ${token}`;
